// extracted by mini-css-extract-plugin
export var divider = "_4a-0";
export var dividerText = "_4a-1";